<template>
  <div class="first-access-page">
    <section>
      <h1 class="title">
        Complete seu cadastro e participe de campanhas incríveis
      </h1>
      <p>
        Para acessar todas as funcionalidades do Clube Venda e Ganhe é
        necessário preencher alguns dados.
      </p>
      <b-notification type="is-warning"
        >O ENVIO DO CARTÃO É FEITO AUTOMATICAMENTE APÓS O PREENCHIMENTO DESTE
        FORMULÁRIO. POR ISSO, ATENÇÃO AO PREENCHIMENTO CORRETO DOS DADOS DE
        ENDEREÇO, PORQUE É PARA ELE QUE ENVIAREMOS O MESMO.</b-notification
      >
    </section>
    <section class="user-form-section">
      <user-form
        @submit="onSubmit"
        :firstAccess="true"
        :errors="errors"
        :cpf="cpf" 
      ></user-form>
    </section>
  </div>
</template>

<script>
import { FINISH_FIRST, CANCEL_FIRST } from '@/store/actions/auth'; 
import UserForm from '@/components/Forms/User/UserForm.vue';

export default {
  name: 'first-access-page',
  components: {
    UserForm,
  },
  data: () => {
    return {
      success: false,
      errors: {},
    };
  },
  computed: {
    cpf() {
      return this.$store.state.auth.firstAccessCpf;
    },
  },
  methods: {
    onSubmit(client) {
      this.$store
        .dispatch(FINISH_FIRST, client)
        .then(() => {
          this.toastify('Cadastro realizado com sucesso!');
          this.$router.push('/');
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar finalizar seu cadastro.',
              'error'
            );
        });
    },
  },
  beforeDestroy() {
    !this.success && this.$store.dispatch(CANCEL_FIRST);
  },
};
</script>

<style lang="scss" scoped>
div.first-access-page {
  padding: 64px 20vw;

  h1.title {
    font-family: var(--font-family-secondary);
    text-align: center;
    color: var(--color-primary-shade);
    font-weight: bold;
  }

  p {
    font-family: var(--font-family-secondary);
    text-align: center;
    color: var(--text-color-light);
    font-weight: 500;
  }

  .notification {
    margin-top: 32px;
  }
}

section.user-form-section {
  margin-top: 32px;
}
</style>
